import React from 'react';
import { motion } from 'framer-motion';
import { Hammer, PenTool, Award, Scroll } from 'lucide-react';
const missions = [{
  icon: Hammer,
  title: 'Ręczna Robota',
  description: 'Każdy element tworzymy ręcznie, z dbałością o najmniejszy detal, tak jak robili to mistrzowie rzemiosła dekady temu.'
}, {
  icon: PenTool,
  title: 'Autentyczny Styl',
  description: 'Inspirujemy się klasycznym wzornictwem lat 50-tych. Nie kopiujemy – wskrzeszamy ducha dawnej typografii.'
}, {
  icon: Award,
  title: 'Złota Jakość',
  description: 'Używamy tylko szlachetnych materiałów: prawdziwego złota płatkowego, emalii i sezonowanego drewna.'
}];
export function Mission() {
  return <section className="relative py-24 bg-[#f4f1e8] text-[#2c2c2c] overflow-hidden" data-id="element-70">
      <div className="absolute inset-0 bg-texture-paper opacity-40 pointer-events-none" data-id="element-71"></div>

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-72">
        <div className="text-center mb-20" data-id="element-73">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-74">
            <h2 className="font-display text-5xl md:text-7xl text-[#1a3a2e] mb-4" data-id="element-75">
              Nasza Misja
            </h2>
            <div className="flex justify-center items-center gap-4" data-id="element-76">
              <div className="h-px w-12 bg-[#1a3a2e]" data-id="element-77"></div>
              <Scroll className="w-6 h-6 text-[#d4af37]" data-id="element-78" />
              <div className="h-px w-12 bg-[#1a3a2e]" data-id="element-79"></div>
            </div>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-80">
          {missions.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.8
        }} className="flex flex-col items-center text-center group" data-id="element-81">
              <div className="w-24 h-24 rounded-full border-4 border-[#1a3a2e] flex items-center justify-center mb-6 bg-[#f4f1e8] shadow-[4px_4px_0px_0px_rgba(26,58,46,1)] transition-transform duration-300 group-hover:-translate-y-2" data-id="element-82">
                <item.icon className="w-10 h-10 text-[#1a3a2e]" strokeWidth={1.5} data-id="element-83" />
              </div>
              <h3 className="font-display text-3xl text-[#1a3a2e] mb-4" data-id="element-84">
                {item.title}
              </h3>
              <p className="font-serif text-lg leading-relaxed text-gray-700 max-w-xs" data-id="element-85">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}